module.exports = __webpack_public_path__ + "img/Z86Q_16.792a61de.jpg";